import { useContext, useEffect, useRef } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { logAnalyticsPageView } from '../helpers/analytics';
import RootContext from '../services/context-states/root-context';
import { NavigationTracker } from '../services/navigationTracking/NavigationTracker';

// Singleton tracker instance
let tracker: NavigationTracker | null = null;

const getTracker = (): NavigationTracker => {
  if (!tracker) {
    tracker = new NavigationTracker();
  }
  return tracker;
};

const AnalyticsNavigated = () => {
  const { pathname, search } = useLocation();
  const { userContext } = useContext(RootContext);
  const currentUser = userContext.currentUser;
  const trackerRef = useRef(getTracker());

  useEffect(() => {
    if (currentUser?.id) {
      trackerRef.current.setUserId(currentUser.id);
    }
  }, [currentUser?.id]);

  useEffect(() => {
    const fullPath = pathname + search;

    // Google Analytics (existing)
    logAnalyticsPageView(fullPath);

    // Custom navigation tracking (logged-in users only)
    if (currentUser?.id) {
      trackerRef.current.track(fullPath);
    }
  }, [pathname, search, currentUser?.id]);

  useEffect(() => {
    return () => {
      trackerRef.current.destroy();
      tracker = null;
    };
  }, []);

  return <Outlet />;
};

export default AnalyticsNavigated;
